import React from 'react'
import shortid from 'shortid'
import classNames from 'classnames'
import ReactMarkdown from 'react-markdown'

import styles from '../component-styles/campaign-code-generator.module.scss'
import { getValidationStatus } from '../helpers/campaign-codes'

interface UrlValidationMessageProps {
  url: string[]
  recentlyValidatedUrls: any
  validationChecks: any
}

export default function UrlValidationMessage({
  url,
  recentlyValidatedUrls,
  validationChecks,
}: UrlValidationMessageProps): React.ReactElement | null {
  return (
    <>
      {url.map((u) => {
        const validationStatus = getValidationStatus(
          recentlyValidatedUrls,
          u,
          validationChecks,
        )
        if (!validationStatus || validationStatus.length === 0) {
          return null
        }
        const statusWeight = {
          valid: 0,
          warning: 5,
          invalid: 10,
        }
        let resultStatus = 'valid'
        validationStatus.forEach((item) => {
          if (statusWeight[item.status] > statusWeight[resultStatus]) {
            resultStatus = item.status
          }
        })
        return (
          <div
            key={shortid.generate()}
            className={classNames(styles.validationCheck, {
              [styles.urlIsBad]: resultStatus === 'invalid',
              [styles.urlIsGood]: resultStatus === 'valid',
              [styles.urlValidating]: resultStatus === 'validating',
              [styles.urlWarning]: resultStatus === 'warning',
            })}
          >
            {validationStatus.map((item) => {
              const { status, message } = item
              return (
                <div
                  key={shortid.generate()}
                  className={classNames(styles.validationCheckItem, {
                    [styles.urlIsBad]: status === 'invalid',
                    [styles.urlIsGood]: status === 'valid',
                    [styles.urlValidating]: status === 'validating',
                    [styles.urlWarning]: status === 'warning',
                  })}
                >
                  <ReactMarkdown source={message} linkTarget="_blank" />
                </div>
              )
              return null
            })}
          </div>
        )
      })}
    </>
  )
}
